import React from 'react';

interface TimelineSelectorProps {
  timeline: '2weeks' | '1month' | 'superfast';
  setTimeline: (timeline: '2weeks' | '1month' | 'superfast') => void;
}

const TimelineSelector: React.FC<TimelineSelectorProps> = ({ timeline, setTimeline }) => {
  const timelines = [
    {
      id: '1month',
      title: '1 Maand',
      description: 'Rustig tempo',
      multiplier: 1,
    },
    {
      id: '2weeks',
      title: '2 Weken',
      description: '+25% Tarief',
      multiplier: 1.25,
    },
    {
      id: 'superfast',
      title: 'Super Snel!',
      description: '+50% Tarief (1 Week)',
      multiplier: 1.5,
      highlight: true,
    },
  ];

  return (
    <div className="mt-12 space-y-6 sm:space-y-8">
      <div className="flex items-center justify-center">
        <div className="flex-1 h-px bg-gray-300"></div>
        <h2 className="text-2xl sm:text-3xl font-bold text-blue-900 text-center px-4 sm:px-6">Tijdsduur:</h2>
        <div className="flex-1 h-px bg-gray-300"></div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
        {timelines.map((tl) => (
          <button
            key={tl.id}
            onClick={() => setTimeline(tl.id as any)}
            className={`px-4 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold transition transform hover:scale-105 ${
              timeline === tl.id
                ? 'text-white ring-4 ' + (tl.highlight ? 'ring-orange-300' : 'ring-blue-300')
                : tl.highlight
                ? 'text-white'
                : 'bg-white text-blue-900 hover:bg-blue-50'
            }`}
            style={
              timeline === tl.id ? (
                tl.highlight ? {
                  background: 'radial-gradient(circle at center, #ff8a3d 0%, #f06c28 45%, #d4551b 100%)'
                } : {
                  background: 'linear-gradient(135deg, #0e2a5a 0%, #1f4fa3 50%, #2c66c3 100%)'
                }
              ) : tl.highlight ? {
                background: 'radial-gradient(circle at center, #ff8a3d 0%, #f06c28 45%, #d4551b 100%)'
              } : {}
            }
          >
            <div className="text-base sm:text-lg font-bold">{tl.title}</div>
            {tl.description && (
              <div className="text-xs sm:text-sm opacity-90 mt-1">{tl.description}</div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TimelineSelector;